import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { colors } from 'style/config';
import { Divider, Text, Link } from 'components/ui';

const GcPurchaseUnavailablePayments = ({
    isPayPalEnabled,
    isPayPalPayLaterEligible,
    isKlarnaEnabledForThisOrder,
    isAfterpayEnabledForThisOrder,
    isAfterpayEnabledForThisProfile,
    localization,
    onAlternatePaymentDetails
}) => {
    const unavailablePayments = [];

    if (isPayPalEnabled && isPayPalPayLaterEligible) {
        unavailablePayments.push('PayPal');
    }

    if (isKlarnaEnabledForThisOrder) {
        unavailablePayments.push('Klarna');
    }

    if (isAfterpayEnabledForThisOrder && isAfterpayEnabledForThisProfile) {
        unavailablePayments.push('Afterpay');
    }

    if (!unavailablePayments.length) {
        return null;
    }

    return (
        <>
            <Divider
                marginTop={[3, 4]}
                color={colors.lightGray}
            />
            <Text
                is='p'
                fontSize='sm'
                marginX={[4, 5]}
                marginTop={[3, 4]}
                lineHeight='tight'
            >
                {unavailablePayments.map((method, index) => {
                    const isLast = index === unavailablePayments.length - 1;
                    const isSecondLast = index === unavailablePayments.length - 2;
                    const separator = unavailablePayments.length === 2 || isSecondLast ? localization.and : ', ';

                    return (
                        <React.Fragment key={method}>
                            <Text fontWeight='bold'>{method}</Text>
                            {!isLast && separator}
                        </React.Fragment>
                    );
                })}
                {` ${localization.cannotBeUsedWhenPurchasingGiftCards} `}
                <Link
                    onClick={onAlternatePaymentDetails}
                    color='blue'
                    css={{ textDecoration: 'underline' }}
                >
                    {localization.seeDetails}
                </Link>
            </Text>
        </>
    );
};

export default wrapFunctionalComponent(GcPurchaseUnavailablePayments, 'GcPurchaseUnavailablePayments');
